export const ACCOUNT_MODE = 'ACCOUNT_MODE';

export const changeAccountMode = q => ({
  type: ACCOUNT_MODE,
  payload: q
});
